import Meta from '@/components/common/Meta'

import OfficeMovingAndStoragePage from '@/v2/components/pages/landing-pages/office-moving-and-storage-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/office-moving-and-storage-page'

interface OfficeMovingAndStoragePageProps {}

const Page: React.FC<OfficeMovingAndStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.office_moving_and_storage.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.office_moving_and_storage?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.office_moving_and_storage?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <OfficeMovingAndStoragePage />
    </>
  )
}

export default Page
